export const visibleColumnData = {
  contactName: true,
  email: true,
  mobile: true,
  contactType_Display: true,
  priority_Display: true,
  country_Display: false,
  curriculum_Display: false,
  grade_Display: false,
  jobTitle: false,
  nationality_Display: false,
  schoolName: false,
  userAssigned: false,
  lastEmailReceivedOnDisplay: false,
  createdOnDisplay: true,
};
